import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCodeFrame16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconCodeFrame16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13 3H3a1 1 0 0 0-1 1v1h12V4a1 1 0 0 0-1-1m1 3H2v6a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1zM3 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm6.152 5.88a.5.5 0 0 0-.933-.359l-1.405 3.66a.5.5 0 1 0 .934.358zm-3.129-.53a.5.5 0 0 1 0 .707L4.546 9.536l1.477 1.477a.5.5 0 1 1-.707.707l-1.83-1.83-.354-.354.353-.354 1.831-1.83a.5.5 0 0 1 .707 0m3.954 0a.5.5 0 0 0 0 .707l1.477 1.478-1.477 1.477a.5.5 0 0 0 .707.707l1.83-1.83.354-.354-.353-.354-1.831-1.83a.5.5 0 0 0-.707 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCodeFrame16);
